import { getCookie } from '@miro-site/core';

var sanitizedBoardKey = function sanitizedBoardKey(embedBoardKey) {
  return embedBoardKey.replace('=', '');
};

export var isBoardExist = function isBoardExist(embedBoardKey) {
  return !!getCookie("EDITABLE_TEMPLATES-".concat(sanitizedBoardKey(embedBoardKey), "-temporaryBoardCreatedByMeToken"));
};
export var isBoardInitiated = function isBoardInitiated(embedBoardKey) {
  return !!getCookie("EDITABLE_TEMPLATES-".concat(sanitizedBoardKey(embedBoardKey), "-temporaryBoardInitiated"));
};